import type { PaymentMethodView } from "../shared/api";

export const euros = (cents: number) => `${(cents / 100).toFixed(2).replace(".", ",")} €`;
export const mmss = (sec: number) =>
  `${String(Math.floor(sec / 60)).padStart(2, "0")}:${String(sec % 60).padStart(2, "0")}`;
export const km = (meters: number) => `${(meters / 1000).toFixed(1).replace(".", ",")} km`;
export const minutes = (sec: number) => `${Math.max(1, Math.ceil(sec / 60))} min`;
/** Recap distance: Pony's, else "calcul…" while Pony computes it, "—" once we stopped asking. */
export const distanceLabel = (
  s: { distanceMeters?: number; distancePending: boolean },
  gaveUp: boolean,
) =>
  s.distanceMeters !== undefined
    ? km(s.distanceMeters)
    : s.distancePending && !gaveUp
      ? "calcul…"
      : "—";
/** Where the hold is taken, as the 05b sheet names it ("réservée sur Apple Pay"). */
export const holdMethodLabel = (m: PaymentMethodView | undefined) =>
  m?.wallet === "apple_pay"
    ? "Apple Pay"
    : m?.last4
      ? `votre carte •••• ${m.last4}`
      : "votre carte";
